<template>



  <v-container
    fluid
    grid-list-xl
  >
    <v-row>
      <v-col cols="10">


        <v-data-table
          :headers="headers"
          :items="incidentTypes"
          :search="search"
          hide-default-footer
          :items-per-page=1000
        >

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>{{$t("incidentTypes.list.title")}}</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-text-field

                :label="$t('global.search')"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="mb-2" v-on="on">{{$t("incidentTypes.list.create")}}</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            :error-messages="nameErrors"
                            required
                            @input="$v.editedItemName.$touch()"
                            @blur="$v.editedItemName.$touch()"
                            v-model="editedItemName" :label="$t('incidentType.name')"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  text @click="close">{{$t('global.cancel')}}</v-btn>
                    <v-btn  color="success" text @click="save">{{$t('global.save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>


          <template v-slot:item.name="{ item }">
            {{item.name}}
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon  v-if="item.deleteable"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>

        </v-data-table>

      </v-col>


    </v-row>


  </v-container>



</template>

<script>
    import api from '../components/backend/backend-api'
    import {required} from "vuelidate/lib/validators";

    export default {
        validations: {
          editedItemName: {
          required,
            isUnique(value) {
              if (value === '') return true
              let currentId = this.editedItem.id
              let existingItems = this.incidentTypes.filter(function (ele) {
                return ele.name ==value && ele.id != currentId
              })
              return existingItems.length == 0
            }

        }
      },
        data: function () {
            return {
                dialog: false,
                editedIndex: -1,
                search: '',
                headers: [
                    {
                        sortable: true,
                        text: this.$i18n.t("incidentType.name"),
                        value: 'name'
                    },
                    {
                        sortable: false,
                        text: this.$i18n.t("global.actions"),
                        value: 'action'
                    }
                ],
                incidentTypes: [],
                editedItem: {
                    id:0,
                    name: '',
                },
              editedItemName:"",
                defaultItem: {
                    id:0,
                    name: '',
                },
            }
        },
        methods:
            {

                getIncidentTypes() {
                    api.getIncidentTypes().then(response => {
                        this.incidentTypes = response
                        //   console.log(response.data)
                    })
                        .catch(error => {
                            this.$store.commit('setErrorMsg', error)
                            console.log(error)
                            //    this.errors.push(error)
                        })
                },



                editItem (item) {
                    this.editedIndex = this.incidentTypes.indexOf(item)
                    this.editedItem = Object.assign({}, item)
                  this.editedItemName = this.editedItem.name
                    this.dialog = true
                },

                deleteItem (item) {
                    if (confirm(this.$i18n.t('incidentTypes.list.delete.body')))
                    {
                        api.deleteIncidentType(item.id).then(response => {
                            const index = this.incidentTypes.indexOf(item)
                            this.incidentTypes.splice(index, 1)
                        })
                            .catch(error => {
                                this.$store.commit('setErrorMsg', error)
                                console.log(error)
                                //    this.errors.push(error)
                            })


                    }
                },

                close () {
                    this.dialog = false
                    setTimeout(() => {
                        this.editedItem = Object.assign({}, this.defaultItem)
                        this.editedIndex = -1
                    }, 300)
                },

                save () {
                   this.$v.$touch()
                  if (!this.$v.$invalid) {
                    if (this.editedIndex > -1) {

                      this.editedItem.name = this.editedItemName
                      api.editIncidentType(this.editedItem.id, this.editedItemName).then(response => {
                        Object.assign(this.incidentTypes[this.editedIndex], this.editedItem)
                        this.editedItemName = ""
                        this.close()
                      })
                        .catch(error => {
                          this.$store.commit('setErrorMsg', error)
                          console.log(error)
                          //    this.errors.push(error)
                        })




                    } else {
                      api.createIncidentType(this.editedItemName).then(response => {
                        this.editedItem.id = response.id
                        this.editedItem.name = this.editedItemName
                        this.editedItem.deleteable = true
                        this.incidentTypes.push(this.editedItem)
                        this.editedItemName = ""
                        this.close()
                        //   console.log(response.data)
                      })
                        .catch(error => {
                          this.$store.commit('setErrorMsg', error)
                          console.log(error)
                          //    this.errors.push(error)
                        })



                    }
                  }



                },





            },
        computed: {
        nameErrors () {
          const errors = []
          if (!this.$v.editedItemName.$dirty) return errors
          !this.$v.editedItemName.required && errors.push(this.$t('validation.required', [this.$t('incidentType.name')]))
                 !this.$v.editedItemName.isUnique && errors.push(this.$t('validation.unique', [this.$t('incidentType.name')]))

          return errors
        },
            formTitle() {
                return this.editedIndex === -1 ? this.$i18n.t('incidentTypes.create.title') : this.$i18n.t('incidentTypes.edit.title')
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },

        mounted() {
            this.getIncidentTypes();
        },
    }
</script>
